var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIcInfo16Dp = function SvgIcInfo16Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 0a8 8 0 110 16A8 8 0 018 0zm-.553 6.187c-.748 0-1.62.313-2.315.57l-.173.641c.312-.106.656-.206.967-.206.638 0 .872.15.872.712 0 .326-.112.738-.204 1.054-.52 1.678-.811 2.376-.811 3.177 0 .428.174.78.521 1.058 1.167.934 3.19.057 3.774-.152l.172-.642c-.43.184-1.3.328-1.668.057-.374-.274-.132-1.198.001-1.617l.645-2.073a4.1 4.1 0 00.164-1.104c0-.966-.824-1.475-1.945-1.475zm1.647-3.812c-.777 0-1.406.572-1.406 1.278 0 .706.63 1.279 1.406 1.279.776 0 1.406-.573 1.406-1.279s-.63-1.278-1.406-1.278z"
  }))));
};

export default "/_next/static/ic_info_16dp-5b84dc4dd59431cb3b8b6e463dfa4591svg";
export { SvgIcInfo16Dp as ReactComponent };